import { render, staticRenderFns } from "./packagingModule.vue?vue&type=template&id=60ea9a88&scoped=true&"
import script from "./packagingModule.vue?vue&type=script&lang=js&"
export * from "./packagingModule.vue?vue&type=script&lang=js&"
import style0 from "./packagingModule.vue?vue&type=style&index=0&id=60ea9a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea9a88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ea9a88')) {
      api.createRecord('60ea9a88', component.options)
    } else {
      api.reload('60ea9a88', component.options)
    }
    module.hot.accept("./packagingModule.vue?vue&type=template&id=60ea9a88&scoped=true&", function () {
      api.rerender('60ea9a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/packagingModule.vue"
export default component.exports